/* Native product grid: filter drawer, sort, swatches, load more, compare */
(function () {
  'use strict';

  const YES_ICON = '<svg class="ngrid__yes" viewBox="0 0 24 24" fill="none" aria-label="Yes"><path d="M5 13.3636L8.03559 16.3204C8.42388 16.6986 9.04279 16.6986 9.43108 16.3204L19 7" stroke="#16b10b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  const NO_ICON = '<svg class="ngrid__no" viewBox="0 0 24 24" fill="none" aria-label="No"><path d="M16 8L8 16M8.00001 8L16 16" stroke="#e11919" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function init(root) {
    const sectionId = root.dataset.sectionId;
    const products = root.querySelector('[data-products]');
    if (!products) return;
    const compareMax = parseInt(root.dataset.compareMax || '3', 10);
    const total = parseInt(root.dataset.total || '0', 10);
    const selected = new Map();
    // Storefront text comes translated from the section (data-i18n-* on the grid root); English is the fallback
    const i18n = (name, fallback) => root.dataset[name] || fallback;

    /* ---------- Filter drawer ---------- */
    const drawer = root.querySelector('.ngrid__drawer');
    const backdrop = root.querySelector('.ngrid__backdrop');
    const openBtn = root.querySelector('[data-open-filters]');
    // The drawer is a modal dialog (WCAG 2.4.3 / 2.1.2): focus moves in on open, Tab
    // cycles inside it, and focus returns to the Filter button on close.
    const focusables = () => Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, summary, [tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
    function trapTab(e) {
      if (e.key !== 'Tab') return;
      const f = focusables(); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function openDrawer() {
      drawer.hidden = false; backdrop.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        const close = drawer.querySelector('[data-close-filters]');
        (close || focusables()[0])?.focus();
      });
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      drawer.addEventListener('keydown', trapTab);
    }
    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      drawer.removeEventListener('keydown', trapTab);
      if (drawer.contains(document.activeElement) || document.activeElement === document.body) openBtn.focus();
      setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 300);
    }
    // Active-filter badge: count checked boxes in the drawer (a colour family counts once)
    (function syncBadge() {
      if (!openBtn || !drawer) return;
      const n = drawer.querySelectorAll('input[type=checkbox]:checked').length;
      let badge = openBtn.querySelector('.ngrid__filter-count');
      if (n === 0) { badge && badge.remove(); return; }
      if (!badge) { badge = document.createElement('span'); badge.className = 'ngrid__filter-count'; openBtn.appendChild(badge); }
      badge.textContent = n;
    })();
    openBtn && openBtn.addEventListener('click', openDrawer);
    root.querySelectorAll('[data-close-filters]').forEach((el) => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeCompare(); closeSort(); } });

    // Price buckets: single choice, writes hidden min/max
    const bucketInputs = root.querySelectorAll('[data-price-bucket]');
    bucketInputs.forEach((cb) => cb.addEventListener('change', () => {
      bucketInputs.forEach((o) => { if (o !== cb) o.checked = false; });
      const min = root.querySelector('[data-price-min]');
      const max = root.querySelector('[data-price-max]');
      if (min) min.value = cb.checked ? cb.dataset.min : '';
      if (max) max.value = cb.checked ? cb.dataset.max : '';
    }));
    // Drop empty fields so URLs stay clean
    const form = root.querySelector('[data-filter-form]');
    form && form.addEventListener('submit', () => {
      form.querySelectorAll('input[type=hidden]').forEach((i) => { if (i.value === '') i.disabled = true; });
      // Colour families: one checkbox submits every underlying colour value
      form.querySelectorAll('[data-color-family]:checked').forEach((cb) => {
        cb.dataset.values.split('|~|').map((v) => v.trim()).filter(Boolean).forEach((v) => {
          const h = document.createElement('input');
          h.type = 'hidden'; h.name = cb.dataset.param; h.value = v;
          form.appendChild(h);
        });
      });
    });

    /* ---------- Sort ---------- */
    const sortToggle = root.querySelector('[data-sort-toggle]');
    const sortList = root.querySelector('[data-sort-list]');
    const sortLabel = root.querySelector('[data-sort-label]');
    const urlSort = new URLSearchParams(window.location.search).get('sort_by') || '';
    if (urlSort) root.dataset.requestedSort = urlSort;
    const currentSort = urlSort || root.dataset.sort;
    if (urlSort && form && !form.querySelector('input[name=sort_by]')) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'sort_by'; hidden.value = urlSort;
      form.appendChild(hidden);
    }
    if (sortLabel) {
      const mostRelevant = i18n('i18nSortMostRelevant', 'Most Relevant');
      const labels = { 'most-relevant': mostRelevant, manual: mostRelevant, rating: i18n('i18nSortRating', 'Top Rated'), 'best-selling': i18n('i18nSortBestSelling', 'Best Sellers'), 'price-descending': i18n('i18nSortPriceDescending', 'Price (High to Low)'), 'price-ascending': i18n('i18nSortPriceAscending', 'Price (Low to High)'), 'created-descending': i18n('i18nSortCreatedDescending', 'Newest') };
      if (urlSort && labels[urlSort]) sortLabel.textContent = labels[urlSort];
      if (sortToggle) sortToggle.setAttribute('aria-label', i18n('i18nSortBy', 'Sort by: [label]').replace('[label]', () => sortLabel.textContent.trim()));
    }
    function closeSort() { if (sortList) { sortList.hidden = true; sortToggle.setAttribute('aria-expanded', 'false'); } }
    if (sortToggle) {
      sortList.querySelectorAll('.ngrid__sort-option').forEach((li) => {
        // No sort in the URL: the collection's default option (marked in Liquid, not matched by its translated text)
        const isSelected = urlSort ? li.dataset.sortValue === urlSort : li.hasAttribute('data-sort-default');
        li.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        li.addEventListener('click', () => {
          const value = li.dataset.sortValue;
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
      sortToggle.addEventListener('click', () => {
        const open = sortList.hidden;
        sortList.hidden = !open;
        sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && sortToggle.matches(':focus-visible')) focusOption(selectedIndex());
      });
      document.addEventListener('click', (e) => { if (!e.target.closest('[data-sort-wrapper]')) closeSort(); });

      // Keyboard support for the sort listbox (WCAG 2.1.1): options are focusable with
      // a roving tabindex; Up/Down/Home/End move, Enter/Space choose, Escape/Tab close.
      const options = Array.from(sortList.querySelectorAll('.ngrid__sort-option'));
      options.forEach((li) => li.setAttribute('tabindex', '-1'));
      const selectedIndex = () => Math.max(0, options.findIndex((li) => li.getAttribute('aria-selected') === 'true'));
      function focusOption(i) {
        const n = (i + options.length) % options.length;
        options.forEach((li, j) => li.setAttribute('tabindex', j === n ? '0' : '-1'));
        options[n].focus();
      }
      sortToggle.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          sortList.hidden = false;
          sortToggle.setAttribute('aria-expanded', 'true');
          focusOption(selectedIndex());
        }
      });
      sortList.addEventListener('keydown', (e) => {
        const i = options.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); focusOption(i + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); focusOption(i - 1); }
        else if (e.key === 'Home') { e.preventDefault(); focusOption(0); }
        else if (e.key === 'End') { e.preventDefault(); focusOption(options.length - 1); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i >= 0) options[i].click(); }
        else if (e.key === 'Escape') { e.preventDefault(); closeSort(); sortToggle.focus(); }
        else if (e.key === 'Tab') { closeSort(); }
      });
    }

    /* ---------- Grid layout (bind early so mobile 1-col always works) ---------- */
    const layoutControls = root.querySelector('[data-grid-layout-controls]');
    const mobileMq = window.matchMedia('(max-width: 989px)');
    const storagePrefix = 'ngrid-grid-view-';

    function currentViewport() {
      return mobileMq.matches ? 'mobile' : 'desktop';
    }

    function isMobileLayoutInput(input) {
      return input.name.indexOf('ngrid-mobile-') !== -1;
    }

    function normalizeLayout(viewport, value) {
      if (viewport === 'mobile') {
        return value === 'mobile-single' ? 'mobile-single' : 'default';
      }
      if (value === 'cols-5' || value === 'zoom-out') return value;
      return 'default';
    }

    function applyGridLayout(value, viewport) {
      if (!products) return;
      const layout = normalizeLayout(viewport, value);
      products.setAttribute('data-ngrid-view', layout);
      root.classList.toggle('ngrid--mobile-single', viewport === 'mobile' && layout === 'mobile-single');
      root.classList.toggle('ngrid--zoom-out', viewport === 'desktop' && layout === 'zoom-out');
      products.classList.toggle('ngrid__products--mobile-single', viewport === 'mobile' && layout === 'mobile-single');
      products.removeAttribute('product-grid-view');
      products.style.removeProperty('grid-template-columns');

      if (viewport === 'mobile') {
        if (layout === 'mobile-single') {
          products.style.setProperty('grid-template-columns', '1fr', 'important');
          products.querySelectorAll(':scope > .ngrid__product-cell, :scope > .ngrid__card, :scope > .ngrid__promo').forEach((cell) => {
            cell.style.gridColumn = 'unset';
            cell.style.gridRow = 'unset';
          });
        } else {
          products.style.setProperty('grid-template-columns', 'repeat(2, minmax(0, 1fr))', 'important');
          products.querySelectorAll(':scope > .ngrid__product-cell, :scope > .ngrid__card, :scope > .ngrid__promo').forEach((cell) => {
            cell.style.removeProperty('grid-column');
            cell.style.removeProperty('grid-row');
          });
        }
      } else if (layout === 'zoom-out') {
        products.setAttribute('product-grid-view', 'zoom-out');
      }

      if (typeof syncPromoHeight === 'function') syncPromoHeight();
      syncCardImageSizes();
    }

    /* Card photo sizes for the other grid views. The server sizes attribute describes the default grid
       (4 columns, 2 on phones). A photo fetched far larger than it draws turns the luggage weave into
       moire in Chrome; one fetched too small blurs. */
    const CARD_VIEW_SIZES = {
      'mobile-single': '100vw',
      'cols-5': '(min-width: 1480px) 264px, (min-width: 1200px) calc((100vw - 160px) / 5), calc((100vw - 80px) / 5)',
    };
    function syncCardImageSizes(scope) {
      if (!products) return;
      const view = products.getAttribute('data-ngrid-view');
      (scope || products).querySelectorAll('.card-gallery img.product-media__image').forEach((img) => {
        if (!img.hasAttribute('data-default-sizes')) img.setAttribute('data-default-sizes', img.getAttribute('sizes') || '');
        const next = CARD_VIEW_SIZES[view] || img.getAttribute('data-default-sizes');
        if (next && img.getAttribute('sizes') !== next) img.setAttribute('sizes', next);
      });
    }

    function getStoredLayout(viewport) {
      if (root.dataset.isSearch === 'true') return 'default';
      const stored = sessionStorage.getItem(storagePrefix + viewport) || 'default';
      return normalizeLayout(viewport, stored);
    }

    function storeLayout(viewport, value) {
      if (root.dataset.isSearch === 'true') return;
      sessionStorage.setItem(storagePrefix + viewport, value);
    }

    function syncLayoutInputs(viewport, value) {
      if (!layoutControls) return;
      const selector = viewport === 'desktop'
        ? 'input[name^="ngrid-desktop-"]'
        : 'input[name^="ngrid-mobile-"]';
      layoutControls.querySelectorAll(selector).forEach((input) => {
        input.checked = input.value === value;
      });
    }

    function applyLayoutForCurrentViewport() {
      const viewport = currentViewport();
      applyGridLayout(getStoredLayout(viewport), viewport);
      syncLayoutInputs(viewport, getStoredLayout(viewport));
    }

    function handleLayoutInput(input) {
      if (!input || input.type !== 'radio') return;
      const storageViewport = isMobileLayoutInput(input) ? 'mobile' : 'desktop';
      storeLayout(storageViewport, input.value);
      if (storageViewport === currentViewport()) {
        applyGridLayout(input.value, storageViewport);
        syncLayoutInputs(storageViewport, normalizeLayout(storageViewport, input.value));
      } else {
        applyLayoutForCurrentViewport();
      }
    }

    if (layoutControls && products) {
      layoutControls.addEventListener('change', (e) => {
        const input = e.target.closest('[data-ngrid-layout-input]');
        if (input && input.checked) handleLayoutInput(input);
      });
      layoutControls.addEventListener('click', (e) => {
        const input = e.target.closest('[data-ngrid-layout-input]');
        if (!input) return;
        requestAnimationFrame(() => {
          if (input.checked) handleLayoutInput(input);
        });
      });

      const handleViewportChange = () => applyLayoutForCurrentViewport();
      applyLayoutForCurrentViewport();
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', handleViewportChange);
      else mobileMq.addListener(handleViewportChange);
    }

    /* ---------- Cards: swatches + compare ---------- */
    // Swatch fallback: if the colour image file is missing, paint a family colour from the name
    const FAMILY_COLOURS = [['black|onyx|jet|shadow|charcoal|ebony|carbon|graphite','#111'],['grey|gray|slate|titanium|silver|pewter|stone|ash|vintage|gunmetal','#8a8a8a'],['navy','#1f3a63'],['blue|azure|baltic|ocean|sky|teal|indigo|denim|cobalt|patriot|ensign|estate','#24507f'],['green|sage|olive|forest|khaki|moss','#6b7a55'],['pink|rose|orchid|lilac|blush|powder|mauve','#d9a5b3'],['red|bordeaux|crimson|burgundy|wine|tibetan|cherry','#9a2530'],['brown|espresso|tan|taupe|mocha|chocolate|bronze|cognac|walnut|coffee','#4a3226'],['white|ivory|cream|sand|pearl|bone|diamond','#fafafa'],['purple|violet|plum|lavender','#6b4a8a']];
    function swatchFallback(sw) {
      const m = (sw.style.backgroundImage || '').match(/url\(["']?([^"')]+)/);
      if (!m) return;
      const probe = new Image();
      probe.onerror = () => {
        const name = (sw.title || '').toLowerCase();
        const hit = FAMILY_COLOURS.find(([kw]) => new RegExp('\\b(' + kw + ')\\b').test(name));
        sw.style.backgroundImage = 'none';
        sw.style.backgroundColor = hit ? hit[1] : '#cfcfcf';
        if (hit && hit[1] === '#fafafa') sw.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.18)';
      };
      probe.src = m[1];
    }
    function wireCard(card) {
      card.querySelectorAll('[data-swatch]').forEach(swatchFallback);
      const primary = card.querySelector('[data-primary-img]');
      const secondary = card.querySelector('[data-secondary-img]');
      card.querySelectorAll('[data-swatch]').forEach((sw) => {
        sw.addEventListener('click', (e) => {
          e.preventDefault();
          card.querySelectorAll('[data-swatch]').forEach((o) => o.classList.remove('is-selected'));
          sw.classList.add('is-selected');
          if (primary && sw.dataset.image) { primary.src = sw.dataset.image; primary.removeAttribute('srcset'); }
          if (secondary) secondary.style.display = 'none';
          card.querySelectorAll('[data-card-link]').forEach((a) => { a.href = sw.dataset.url; });
          card.dataset.variantId = sw.dataset.variantId || card.dataset.variantId;
          card.dataset.variantAvailable = sw.dataset.available || 'true';
          const qa = card.querySelector('[data-quick-add]');
          if (qa) { const ok = card.dataset.variantAvailable === 'true'; qa.disabled = !ok; qa.querySelector('[data-quick-add-label]').textContent = ok ? 'Add to cart' : 'Sold out'; }
          const cn = card.querySelector('[data-color-name]');
          if (cn && sw.dataset.color) cn.textContent = sw.dataset.color.toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());
        });
      });
      const quick = card.querySelector('[data-quick-add]');
      quick && quick.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation();
        if (quick.disabled) return;
        const label = quick.querySelector('[data-quick-add-label]');
        quick.classList.add('is-busy'); label.textContent = 'Adding…';
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
        try {
          const res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(card.dataset.variantId, 10), quantity: 1 }], sections: sectionIds.join(',') })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add');
          const ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: {}, sourceId: 'ngrid-' + card.dataset.productId, data: { source: 'product-form-component', itemCount: 1, productId: card.dataset.productId, variantId: card.dataset.variantId, sections: data.sections } };
          document.dispatchEvent(ev);
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
          label.textContent = 'Added';
        } catch (err) {
          label.textContent = 'Try again';
          console.error(err);
        } finally {
          setTimeout(() => { quick.classList.remove('is-busy'); if (!quick.disabled && label.textContent !== 'Sold out') label.textContent = 'Add to cart'; }, 1500);
        }
      });
      const check = card.querySelector('[data-compare-check]');
      check && check.addEventListener('change', () => {
        const id = card.dataset.productId;
        if (check.checked) {
          if (selected.size >= compareMax) { check.checked = false; return; }
          const data = JSON.parse(card.querySelector('[data-compare-data]').textContent);
          selected.set(id, data);
        } else {
          selected.delete(id);
        }
        renderCompareBar();
      });
    }
    products.querySelectorAll('.ngrid__card').forEach(wireCard);

    /* ---------- Quick add placement: over the tile on hover screens, below the price on touch/narrow ---------- */
    const touchMq = window.matchMedia('(hover: none), (max-width: 989px)');
    function placeQuickAdd() {
      products.querySelectorAll('.ngrid__card').forEach((card) => {
        const btn = card.querySelector('[data-quick-add]');
        if (!btn) return;
        const media = card.querySelector('.ngrid__media');
        const details = card.querySelector('.ngrid__details');
        if (touchMq.matches) { if (btn.parentElement !== details) details.appendChild(btn); btn.classList.add('ngrid__quick-add--inline'); }
        else { if (btn.parentElement !== media) media.appendChild(btn); btn.classList.remove('ngrid__quick-add--inline'); }
      });
    }
    placeQuickAdd();
    touchMq.addEventListener ? touchMq.addEventListener('change', placeQuickAdd) : touchMq.addListener(placeQuickAdd);

    /* ---------- Compare ---------- */
    // Legacy .ngrid__card compare. When the grid carries data-product-compare-root (Horizon cards),
    // product-compare.js owns the bar and the dialog, so none of this may bind or run.
    const ownCompare = !root.hasAttribute('data-product-compare-root');
    const bar = root.querySelector('[data-compare-bar]');
    const barText = root.querySelector('[data-compare-text]');
    const modal = root.querySelector('[data-compare-modal]');
    const modalBackdrop = root.querySelector('.ngrid__compare-backdrop');
    const modalProducts = root.querySelector('[data-compare-products]');
    function renderCompareBar() {
      bar.hidden = selected.size === 0;
      barText.textContent = 'Compare products (' + selected.size + ' of ' + compareMax + ')';
      root.querySelectorAll('[data-compare-check]').forEach((cb) => {
        cb.disabled = !cb.checked && selected.size >= compareMax;
      });
    }
    function truthy(v) { return /^(yes|true|y|1)$/i.test(String(v).trim()); }
    function escapeHtml(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    function specHtml(spec) {
      if (spec.image) {
        if (!spec.value) return '';
        return '<img class="ngrid__compare-alt" src="' + escapeHtml(spec.value) + '" alt="" loading="lazy">';
      }
      if (spec.list) {
        const items = String(spec.value || '').split(/\r?\n|,/).map((s) => s.trim()).filter(Boolean);
        return items.map((it) => '<div class="ngrid__feature"><span>' + YES_ICON + '</span>' + escapeHtml(it) + '</div>').join('');
      }
      if (spec.boolean) {
        if (spec.value === '' || spec.value == null) return '';
        return truthy(spec.value) ? YES_ICON : NO_ICON;
      }
      return escapeHtml(spec.value || '');
    }
    function openCompare() {
      modalProducts.innerHTML = '';
      const list = Array.from(selected.values());
      list.forEach((p) => {
        const col = document.createElement('div');
        col.className = 'ngrid__compare-product';
        col.innerHTML =
          '<div class="img-outer"><img src="' + p.image + '" alt=""></div>' +
          '<a href="' + p.url + '" class="ngrid__compare-name">' + escapeHtml(p.title) + '</a>' +
          '<div class="ngrid__compare-price">' + p.price + '</div>' +
          '<a href="' + p.url + '" class="ngrid__compare-view">View Product</a>' +
          '<div class="ngrid__compare-specs">' +
          p.specs.map((s) => '<div class="ngrid__compare-spec' + (s.image ? ' ngrid__compare-spec--image' : '') + '"><div class="ngrid__compare-title">' + escapeHtml(s.label) + '</div><div class="ngrid__compare-desc">' + specHtml(s) + '</div></div>').join('') +
          '</div>';
        modalProducts.appendChild(col);
      });
      modal.hidden = false; modalBackdrop.hidden = false;
      document.body.style.overflow = 'hidden';
      // Modal focus management (WCAG 2.4.3): move in, contain Tab, return on close.
      compareOpener = document.activeElement;
      modal.addEventListener('keydown', trapCompareTab);
      modal.querySelector('[data-compare-close]')?.focus();
      // Equalise row heights across columns (measured after the modal is visible)
      const cols = modalProducts.querySelectorAll('.ngrid__compare-product');
      const rows = cols[0] ? cols[0].querySelectorAll('.ngrid__compare-spec').length : 0;
      for (let r = 0; r < rows; r++) {
        let h = 0; const cells = [];
        cols.forEach((c) => { const cell = c.querySelectorAll('.ngrid__compare-spec')[r]; if (cell && !cell.classList.contains('ngrid__compare-spec--image')) { cells.push(cell); cell.style.height = ''; } });
        cells.forEach((cell) => { h = Math.max(h, cell.offsetHeight); });
        cells.forEach((cell) => { cell.style.height = h + 'px'; });
      }
    }
    let compareOpener = null;
    function trapCompareTab(e) {
      if (e.key !== 'Tab') return;
      const f = Array.from(modal.querySelectorAll('a[href], button:not([disabled])')).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
    function closeCompare() {
      if (!ownCompare || !modal || modal.hidden) return;
      modal.hidden = true; modalBackdrop.hidden = true;
      document.body.style.overflow = '';
      modal.removeEventListener('keydown', trapCompareTab);
      if (compareOpener && compareOpener.isConnected) compareOpener.focus();
      compareOpener = null;
    }
    const compareStart = root.querySelector('[data-compare-start]');
    if (ownCompare) {
      compareStart && compareStart.addEventListener('click', openCompare);
      root.querySelectorAll('[data-compare-close]').forEach((el) => el.addEventListener('click', closeCompare));
    }

    /* ---------- Promo tiles: position in grid and match product tile height ---------- */
    const cellSelector = '.ngrid__product-cell, .ngrid__card';

    function syncPromoHeight() {
      const shaped = root.classList.contains('ngrid--shape-portrait') || root.classList.contains('ngrid--shape-tall');
      const tile =
        products.querySelector('.ngrid__card .ngrid__media-link') ||
        products.querySelector('.ngrid__product-cell .product-card__media, .ngrid__product-cell .card-gallery');
      products.querySelectorAll('.ngrid__promo-media').forEach((m) => {
        if (shaped && tile) { m.style.height = tile.offsetHeight + 'px'; m.classList.add('is-pinned'); }
        else { m.style.height = ''; m.classList.remove('is-pinned'); }
      });
    }

    /* Promo fit: a promo shows only when products fill every row up to and including its own row.
       The server marks the layouts page 1 cannot fill (ngrid__promo--off-d4/d5/m2/m1, hidden by CSS in
       the section, so view switches and breakpoints need no JS). Recount when the grid gains products. */
    const PROMO_LAYOUTS = ['d4', 'd5', 'm2', 'm1'];
    function syncPromoFit() {
      const count = products.querySelectorAll(':scope > .ngrid__product-cell, :scope > .ngrid__card').length;
      products.querySelectorAll(':scope > .ngrid__promo[data-promo-need-d4]').forEach((p) => {
        PROMO_LAYOUTS.forEach((layout) => {
          const need = parseInt(p.getAttribute('data-promo-need-' + layout), 10);
          if (!isNaN(need)) p.classList.toggle('ngrid__promo--off-' + layout, count < need);
        });
      });
    }

    function placePromos() {
      syncPromoFit();
      Array.from(products.querySelectorAll('.ngrid__promo:not([hidden])')).forEach((p) => {
        const row = parseInt(p.dataset.promoRow || '2', 10);
        const span = parseInt(p.dataset.promoSpan || '2', 10);
        const idx = (row - 1) * 4 + (p.dataset.promoSide === 'left' ? 0 : 4 - span);
        const anchor = products.querySelectorAll(cellSelector)[idx];
        if (anchor) products.insertBefore(p, anchor);
        else products.appendChild(p);
      });
      syncPromoHeight();
    }

    window.addEventListener('resize', syncPromoHeight);

    /* ---------- Search extras: matching pages + blog articles via the predictive search API ---------- */
    const extras = root.querySelector('[data-search-extras]');
    // While loading, the strip shows placeholder cards in space reserved by the server render. Drop them
    // (and the reserved space) only when there is nothing to show.
    const settleExtras = (show) => {
      extras.classList.remove('ngrid__extras--loading');
      extras.removeAttribute('aria-busy');
      extras.hidden = !show;
    };
    if (extras && !extras.dataset.query) settleExtras(false);
    if (extras && extras.dataset.query) {
      const limit = parseInt(extras.dataset.limit || '6', 10);
      const url = '/search/suggest.json?q=' + encodeURIComponent(extras.dataset.query) + '&resources[type]=article,page&resources[limit]=' + limit + '&resources[options][fields]=title,body';
      fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((json) => {
        const res = (json.resources && json.resources.results) || {};
        const items = [].concat(
          (res.articles || []).map((a) => ({ type: i18n('i18nResultArticle', 'Article'), title: a.title, url: a.url, image: a.image, text: a.summary_html || a.body || '' })),
          (res.pages || []).map((p) => ({ type: i18n('i18nResultPage', 'Page'), title: p.title, url: p.url, image: null, text: p.body || '' }))
        );
        // Regional blogs carry duplicate articles (same title in several blogs); show each title once.
        const seen = new Set();
        const unique = items.filter((it) => {
          const key = (it.title || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        // Titles that contain a search word go first ("warranty" -> the Warranty page before blog posts); order is otherwise kept.
        const words = extras.dataset.query.toLowerCase().split(/[^a-z0-9]+/).filter((w) => w.length > 2);
        const titleHit = (it) => (words.some((w) => (it.title || '').toLowerCase().includes(w)) ? 0 : 1);
        unique.sort((a, b) => titleHit(a) - titleHit(b));
        unique.splice(limit);
        if (!unique.length) return settleExtras(false);
        const list = extras.querySelector('[data-extras-list]');
        const strip = (h) => { const d = document.createElement('div'); d.innerHTML = h; return (d.textContent || '').replace(/\s+/g, ' ').trim(); };
        list.innerHTML = unique.map((it) => {
          const media = it.image
            ? '<img class="ngrid__extra-img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') + '" alt="" loading="lazy">'
            : '<div class="ngrid__extra-img ngrid__extra-img--page" aria-hidden="true"><svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/></svg></div>';
          const excerpt = strip(it.text).slice(0, 110);
          return '<li class="ngrid__extra"><a href="' + it.url + '" class="ngrid__extra-link">' + media +
            '<div class="ngrid__extra-body"><div class="ngrid__extra-type">' + escapeHtml(it.type) + '</div><div class="ngrid__extra-title">' + escapeHtml(it.title) + '</div>' +
            (excerpt ? '<div class="ngrid__extra-text">' + escapeHtml(excerpt) + (strip(it.text).length > 110 ? '…' : '') + '</div>' : '') + '</div></a></li>';
        }).join('');
        settleExtras(true);
      }).catch(() => settleExtras(false));
    }

    /* ---------- Set colour switch (grouped set cards) ---------- */
    /* Each colour of a set is its own product. A grouped cell (data-group-members, see
       snippets/ngrid-group-plan) carries one <template data-ngrid-sibling> per colour in its swatch row
       (snippets/ngrid-sibling-data). Tapping a swatch switches the card to that colour in place: photo and
       hover photo, links, colour name, price, badges, quick add and compare. No request is made. Modifier
       clicks (new tab) still open the colour's own page. */
    const CARD_IMAGE_WIDTHS = [240, 352, 450, 550, 650, 832, 1200, 1600, 1920, 2560, 3840];
    function sizedImageUrl(u, width) {
      return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + width) : u + (u.includes('?') ? '&' : '?') + 'width=' + width;
    }
    function siblingData(cell, id) {
      const tpl = cell.querySelector(':scope > template[data-ngrid-sibling="' + CSS.escape(String(id)) + '"]');
      const json = tpl && tpl.content.querySelector('[data-sibling-json]');
      if (!json) return null;
      try {
        const data = JSON.parse(json.textContent);
        data.fragment = tpl.content;
        return data;
      } catch (e) {
        return null;
      }
    }
    function switchSibling(cell, id) {
      const card = cell.querySelector('product-card');
      if (!card) return false;
      const oldId = String(card.dataset.productId || '');
      const s = siblingData(cell, id);
      if (!s) return false;
      const newId = String(s.id);
      if (oldId === newId) return true;
      const cardLink = card.querySelector('[ref="productCardLink"]');
      const oldHref = cardLink ? (cardLink.getAttribute('href') || '').trim() : '';
      const quickAddEl = card.querySelector('quick-add-component');
      const oldTitle = (quickAddEl && quickAddEl.dataset.productTitle) || (cardLink ? cardLink.textContent.trim() : '');
      const inSwatches = (el) => !!el.closest('.bundle-swatch-colors');

      // Links and product ids (the swatch row keeps its own)
      cell.querySelectorAll('a[href]').forEach((a) => {
        if (!inSwatches(a) && (a.getAttribute('href') || '').trim() === oldHref) a.setAttribute('href', s.url);
      });
      [cell, ...cell.querySelectorAll('[data-product-id]')].forEach((el) => {
        if (el.dataset.productId === oldId && !inSwatches(el)) el.dataset.productId = newId;
      });

      // Photo, hover photo (the gallery's media map), badges, award seal
      const gallery = card.querySelector('[ref="cardGallery"]');
      if (gallery && s.media) {
        const img = gallery.querySelector('img.product-media__image');
        if (img) {
          img.srcset = CARD_IMAGE_WIDTHS.map((w) => sizedImageUrl(s.media.u, w) + ' ' + w + 'w').join(', ');
          img.src = sizedImageUrl(s.media.u, 832);
          img.alt = s.media.a || '';
          if (s.media.h) { img.width = 3840; img.height = s.media.h; }
          if (img.hasAttribute('data_max_resolution')) img.setAttribute('data_max_resolution', sizedImageUrl(s.media.u, 3840));
          const mediaRoot = img.closest('.product-media');
          if (mediaRoot) {
            mediaRoot.dataset.mediaId = String(s.media.id);
            if (s.media.r) mediaRoot.style.setProperty('--ratio', String(s.media.r));
          }
        }
        gallery.dataset.initialMediaId = String(s.media.id);
        if (s.second) gallery.dataset.secondMediaId = String(s.second.id);
        else delete gallery.dataset.secondMediaId;
        const map = {};
        map[s.media.id] = { u: s.media.u, a: s.media.a, r: s.media.r };
        if (s.second) map[s.second.id] = { u: s.second.u, a: s.second.a, r: s.second.r };
        const oldMap = gallery.querySelector('script[ref="cardGalleryMediaData"]');
        if (oldMap) {
          // A new element (not new text): product-card.js caches the parsed map per script element
          const nextMap = document.createElement('script');
          nextMap.type = 'application/json';
          nextMap.setAttribute('ref', 'cardGalleryMediaData');
          nextMap.textContent = JSON.stringify(map);
          oldMap.replaceWith(nextMap);
        }
        const badges = gallery.querySelector('.product-badges');
        const nextBadges = s.fragment.querySelector('[data-sibling-part="badges"] .product-badges');
        if (badges && nextBadges) badges.replaceWith(nextBadges.cloneNode(true));
        const seal = gallery.querySelector('.product-card__metafield-badge');
        if (seal) {
          const sealImg = seal.querySelector('img');
          if (s.badge && sealImg) { sealImg.src = s.badge; sealImg.removeAttribute('srcset'); }
          seal.hidden = !s.badge;
        }
      }
      const transitionLink = card.closest('product-card-link');
      if (transitionLink && s.media) transitionLink.dataset.featuredMediaUrl = sizedImageUrl(s.media.u, 500);

      // Prices (the zoomed-out view and the price block; the block may show the sale price first)
      const nextPrice = s.fragment.querySelector('[data-sibling-part="price"] [ref="priceContainer"]');
      if (nextPrice) {
        card.querySelectorAll('product-price').forEach((priceEl) => {
          const current = priceEl.querySelector('[ref="priceContainer"]');
          if (!current) return;
          const next = nextPrice.cloneNode(true);
          if (priceEl.dataset.saleFirst === 'true') {
            const compareGroup = next.querySelector('.compare-at-price')?.closest('[role="group"]');
            if (compareGroup) next.appendChild(compareGroup);
          }
          current.replaceWith(next);
        });
      }

      // Quick add: the colour's variant; sold out reads "Sold out" and stays disabled
      const form = card.querySelector('product-form-component');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) { variantInput.value = String(s.variant); variantInput.disabled = !s.available; }
        const productInput = form.querySelector('input[name="product-id"]');
        if (productInput) productInput.value = newId;
        const addToCart = form.querySelector('add-to-cart-component');
        if (addToCart && s.media) addToCart.dataset.productVariantMedia = sizedImageUrl(s.media.u, 100);
        const soldOutText = form.dataset.soldOutText || 'Sold out';
        form.dataset.addToCartLabel = i18n('i18nAddToCart', 'Add [title] to cart').replace('[title]', () => s.title);
        form.dataset.soldOutLabel = s.title + ' - ' + soldOutText;
        const button = form.querySelector('button[name="add"]');
        if (button) {
          button.disabled = !s.available;
          button.setAttribute('aria-label', s.available ? form.dataset.addToCartLabel : form.dataset.soldOutLabel);
          const text = button.querySelector('.add-to-cart-text__content');
          if (text) text.textContent = s.available ? form.dataset.addToCartText || 'Add to cart' : soldOutText;
        }
      }
      if (quickAddEl) quickAddEl.dataset.productTitle = s.title;

      // Title (colours of a set almost always share it)
      if (oldTitle && s.title && oldTitle !== s.title) {
        card.querySelectorAll('.visually-hidden, .product-card-title-text > p, .product-grid-view-zoom-out--details h3').forEach((el) => {
          if (el.textContent.replace(/\s+/g, ' ').trim() === oldTitle) el.textContent = s.title;
        });
        card.querySelectorAll('[aria-label]').forEach((el) => {
          const label = el.getAttribute('aria-label');
          if (!inSwatches(el) && label && label.includes(oldTitle)) el.setAttribute('aria-label', label.split(oldTitle).join(s.title));
        });
      }

      // Colour name and the pressed swatch
      const colourName = card.querySelector('.product-card__selected-swatch-name');
      if (colourName && s.colour) colourName.textContent = s.colour.toLowerCase();
      card.querySelectorAll('.bundle-swatch-colors__link[data-sibling-id]').forEach((a) => {
        const on = a.dataset.siblingId === newId;
        a.classList.toggle('bundle-swatch-colors__link--active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });

      // Compare: the colour's id, title, link, photo, price and alternate view (the set's specs are shared).
      // A ticked card keeps its place in the comparison, now as this colour.
      const compareData = card.querySelector('[data-compare-data]');
      if (compareData) {
        try {
          const data = JSON.parse(compareData.textContent);
          data.id = Number(newId);
          data.title = s.title;
          data.url = s.url;
          if (s.compare) {
            // The compare photo is the card photo at 500px unless the colour's variant has its own image
            data.image = s.compare.image || (s.media ? sizedImageUrl(s.media.u, 500) : data.image);
            data.price = s.compare.price;
            (data.specs || []).forEach((spec) => { if (spec.image) spec.value = s.compare.alt || ''; });
          }
          compareData.textContent = JSON.stringify(data);
          const check = card.querySelector('[data-compare-check]');
          const compareSelected = root.__compareSelected;
          if (check && check.checked && compareSelected && compareSelected.has(oldId)) {
            const entries = Array.from(compareSelected.entries()).map(([key, value]) => (key === oldId ? [newId, data] : [key, value]));
            compareSelected.clear();
            entries.forEach(([key, value]) => compareSelected.set(key, value));
          }
        } catch (e) {
          /* keep the previous compare data */
        }
      }
      return true;
    }
    // Capture phase: runs before product-card's own click handler, which would otherwise rewrite the URL hash
    products.addEventListener('click', (e) => {
      const swatch = e.target instanceof Element ? e.target.closest('.bundle-swatch-colors__link[data-sibling-id]') : null;
      if (!swatch) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      const cell = swatch.closest('.ngrid__product-cell[data-group-members]');
      if (!cell || cell.parentElement !== products) return;
      if (switchSibling(cell, swatch.dataset.siblingId)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* ---------- Load more ---------- */
    /* Set colours across pages: grouping is worked out per page on the server, which cannot see other pages,
       so the next page can bring a set that is already on a card. Each cell stands for its own product and,
       when grouped, every colour in its swatch row (data-group-members). A cell from the next page is left
       out when its product is already on a card, except that an in-stock card replaces a sold-out card of the
       same set (its in-stock colour was on a later page), and takes over sold-out cards whose colours it
       covers. One Load More keeps fetching pages until it has
       added at least a row of new cards, so a page made only of colours already shown never looks like a
       dead click. "You've viewed X of Y" counts products (Y is the product total Shopify gives, and every
       loaded page covers per_page products), so it still ends at Y of Y. When set colours share cards there
       are fewer cards than products loaded, and ", colors included" ([data-colors-included]) says why; the
       server shows it on the first page by the same rule (snippets/ngrid-grid-footer), and each loaded page
       adds its product count (data-page-products). */
    const loadMore = root.querySelector('[data-load-more]');
    const shownEl = root.querySelector('[data-shown]');
    const colorsNoteEl = root.querySelector('[data-colors-included]');
    const perPage = parseInt(root.dataset.perPage || '24', 10);
    function pageProductCount(pageProducts) {
      const n = parseInt(pageProducts.dataset.pageProducts, 10);
      return Number.isNaN(n) ? pageProducts.querySelectorAll(cellSelector).length : n;
    }
    let loadedProducts = pageProductCount(products);
    function syncColorsNote() {
      if (!colorsNoteEl) return;
      const cards = products.querySelectorAll(':scope > .ngrid__product-cell, :scope > .ngrid__card').length;
      colorsNoteEl.hidden = cards >= loadedProducts;
    }
    const LOAD_MORE_MIN_NEW = 4;
    async function fetchPage(url) {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      const res = await fetch(u.toString());
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-products]');
    }
    function cellProductIds(cell) {
      const ids = (cell.dataset.groupMembers || '').split(/\s+/).filter(Boolean);
      if (cell.dataset.productId) ids.push(cell.dataset.productId);
      return ids;
    }
    function representedProducts() {
      const map = new Map();
      products.querySelectorAll(':scope > .ngrid__product-cell').forEach((cell) => {
        cellProductIds(cell).forEach((id) => map.set(id, cell));
      });
      return map;
    }
    /** Adds a fetched page's cells; returns how many new cards went in. keepOrder: append (Top Rated sorts after). */
    function addCells(nextProducts, keepOrder) {
      const represented = representedProducts();
      let added = 0;
      nextProducts.querySelectorAll(cellSelector).forEach((card) => {
        if (card.classList.contains('ngrid__product-cell')) {
          const existing = card.dataset.productId ? represented.get(card.dataset.productId) : null;
          if (existing) {
            if (!(existing.hasAttribute('data-sold-out') && !card.hasAttribute('data-sold-out'))) return;
            represented.forEach((cell, id) => { if (cell === existing) represented.delete(id); });
            existing.remove();
          }
        } else {
          const key = card.dataset.groupKey;
          if (key && products.querySelector('[data-group-key="' + CSS.escape(key) + '"]')) return;
        }
        // Sold-out products stay at the end of the grid: in-stock cards go in before the first sold-out one
        const firstSoldOut = keepOrder || card.hasAttribute('data-sold-out') ? null : products.querySelector(':scope > [data-sold-out]');
        if (firstSoldOut) products.insertBefore(card, firstSoldOut);
        else products.appendChild(card);
        if (card.classList.contains('ngrid__card')) wireCard(card);
        const cardIds = cellProductIds(card);
        // An in-stock set card also takes over sold-out cards it now covers (a sold-out colour whose own
        // colour list left the others out got its own card on an earlier page)
        if (!card.hasAttribute('data-sold-out') && card.dataset.groupMembers) {
          new Set(represented.values()).forEach((cell) => {
            if (!cell.hasAttribute('data-sold-out') || !cell.isConnected) return;
            if (cellProductIds(cell).every((id) => cardIds.includes(id))) {
              represented.forEach((c, id) => { if (c === cell) represented.delete(id); });
              cell.remove();
            }
          });
        }
        cardIds.forEach((id) => represented.set(id, card));
        added += 1;
      });
      return added;
    }
    function syncShown(nextProducts) {
      if (!shownEl) return;
      const page = parseInt((nextProducts && nextProducts.dataset.page) || '1', 10);
      shownEl.textContent = Math.min(page * perPage, total);
    }
    async function appendNext() {
      if (!products.dataset.nextUrl) return;
      loadMore.disabled = true;
      let added = 0;
      try {
        while (products.dataset.nextUrl && added < LOAD_MORE_MIN_NEW) {
          const nextProducts = await fetchPage(products.dataset.nextUrl);
          if (!nextProducts) break;
          syncCardImageSizes(nextProducts);
          loadedProducts += pageProductCount(nextProducts);
          added += addCells(nextProducts, false);
          products.dataset.nextUrl = nextProducts.dataset.nextUrl || '';
          syncShown(nextProducts);
          syncColorsNote();
        }
      } catch (err) {
        /* network error: keep what was added and let the shopper try again */
      }
      placeQuickAdd();
      placePromos();
      document.dispatchEvent(new CustomEvent('product-compare:refresh'));
      if (!products.dataset.nextUrl) loadMore.remove(); else loadMore.disabled = false;
    }
    loadMore && loadMore.addEventListener('click', appendNext);

    /* ---------- Top Rated: client-side sort over the full result set ---------- */
    /* Cells carry data-rating / data-rating-count (reviews.rating, reviews.rating_count). Horizon cells are
       .ngrid__product-cell; .ngrid__card is the legacy card, still handled. */
    async function applyRatingSort() {
      while (products.dataset.nextUrl) {
        const nextProducts = await fetchPage(products.dataset.nextUrl);
        if (!nextProducts) break;
        syncCardImageSizes(nextProducts);
        loadedProducts += pageProductCount(nextProducts);
        addCells(nextProducts, true);
        products.dataset.nextUrl = nextProducts.dataset.nextUrl || '';
      }
      const cards = Array.from(products.querySelectorAll(':scope > .ngrid__product-cell, :scope > .ngrid__card'));
      cards.sort((a, b) => {
        const soldA = a.hasAttribute('data-sold-out') || !!a.closest('[data-sold-out]');
        const soldB = b.hasAttribute('data-sold-out') || !!b.closest('[data-sold-out]');
        if (soldA !== soldB) return soldA ? 1 : -1;
        const ra = parseFloat(a.dataset.rating) || 0, rb = parseFloat(b.dataset.rating) || 0;
        if (rb !== ra) return rb - ra;
        return (parseInt(b.dataset.ratingCount) || 0) - (parseInt(a.dataset.ratingCount) || 0);
      });
      cards.forEach((c) => products.appendChild(c));
      placePromos();
      // Every page is loaded, so every product is on a card (grouped set colours are on their set's card)
      if (shownEl) shownEl.textContent = total;
      syncColorsNote();
      document.dispatchEvent(new CustomEvent('product-compare:refresh'));
      if (loadMore) loadMore.remove();
      if (sortLabel) sortLabel.textContent = i18n('i18nSortRating', 'Top Rated');
    }
    if (root.dataset.requestedSort === 'rating' && root.dataset.isSearch !== 'true') applyRatingSort();
  }

  function boot() {
    document.querySelectorAll('.ngrid').forEach(function (root) {
      if (root.dataset.inited) return;
      root.dataset.inited = '1';
      try {
        init(root);
      } catch (err) {
        /* init skipped — grid remains server-rendered */
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
